import { SET_CONTEXT } from 'src/services/jira/actions';
import { LOGGED_IN,
  LOGGED_OUT,
  RESTORED_LOGGED_IN,
  RESTORED_LOGGED_OUT } from 'src/services/session/actions';

import { loggedIn, setApiKeyAvailable, setJiraContext, setSidebarInfoAvailable } from './impl';

const middleware = store => next => action => {
  const result = next(action);

  switch (action.type) {
    case RESTORED_LOGGED_IN:
    case LOGGED_IN:
      loggedIn(true);
      break;

    case RESTORED_LOGGED_OUT:
    case LOGGED_OUT:
      loggedIn(false);
      break;

    case SET_CONTEXT:
      const { jira: { settings: { v3AuthToken, pdApiKey }, context } } = store.getState();
      setJiraContext(context);
      setApiKeyAvailable(Boolean(pdApiKey && pdApiKey.value));
      setSidebarInfoAvailable(Boolean(v3AuthToken && v3AuthToken.value));
      break;

    default:
      break;
  }

  return result;
};

export default middleware;
